export const formatString = (str) => str?.replace(/\\n/g, '\n')?.trim();

/**
 * Converts "\n" string to literal line feed, allowing for white-space:pre
 * driven formatting dictated by the content itself.
 * Also trims the strings (as there is a current hack to include "empty" values in
 * content by using a single space).
 *
 * @param {object}  content - Original content object from the screen. All values
 * are processed.
 * @returns {object}
 */
export const formatScreenContent = (content) =>
  Object.keys(content).reduce(
    (acc, k) => ({ ...acc, [k]: formatString(content[k]) }),
    {}
  );
